import { Stepper, Step, StepLabel } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';

interface StepperVerticalProps {
  steps: string[];
  currentStep: number;
  isError: boolean;
}

export function StepperVertical(props: StepperVerticalProps) {
  const { steps, currentStep, isError } = props;
  return (
    steps?.length > 0 && (
      <Stepper activeStep={currentStep} orientation="vertical">
        {steps.map((label, index) => (
          <Step key={index} sx={{ display: 'inline-block', width: '100%', alignItems: 'center' }}>
            <StepLabel
              error={index === currentStep && isError}
              icon={
                index === currentStep && isError ? (
                  <CancelIcon color="error" />
                ) : index <= currentStep ? (
                  <CheckCircleIcon color="primary" />
                ) : (
                  <CircleIcon sx={{ color: '#bdbdbd' }} />
                )
              }
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    )
  );
}

export default StepperVertical;
